import React, { useEffect, useState } from "react";
import { Button, CircularProgress, FormControlLabel, Switch, TextField, Typography } from "@material-ui/core";
import api from "../../services/api";

const AiReports = () => {
  const [config, setConfig] = useState({ configured: false, enabled: false, model: "gpt-4.1-mini", maskedKey: null });
  const [apiKey, setApiKey] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    let mounted = true;
    api.get("/settings/ai-reports")
      .then(response => {
        if (!mounted) return;
        setConfig({
          configured: Boolean(response.data?.configured),
          enabled: Boolean(response.data?.enabled),
          model: response.data?.model || "gpt-4.1-mini",
          maskedKey: response.data?.maskedKey || null,
        });
      })
      .catch(error => {
        if (mounted) setErrorMessage(error?.response?.data?.error || "Não foi possível carregar a configuração de IA.");
      })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  const handleSave = async () => {
    setSaving(true);
    setMessage("");
    setErrorMessage("");
    const payload = { enabled: config.enabled };
    if (apiKey.trim()) payload.apiKey = apiKey;
    try {
      const response = await api.put("/settings/ai-reports", payload);
      setConfig(previous => ({
        ...previous,
        configured: typeof response.data?.configured === "boolean" ? response.data.configured : previous.configured || Boolean(payload.apiKey),
        enabled: typeof response.data?.enabled === "boolean" ? response.data.enabled : config.enabled,
        model: response.data?.model || previous.model,
        maskedKey: Object.prototype.hasOwnProperty.call(response.data || {}, "maskedKey") ? response.data.maskedKey : previous.maskedKey,
      }));
      setApiKey("");
      setMessage("Configuração salva.");
    } catch (error) {
      setErrorMessage(error?.response?.data?.error || "Não foi possível salvar a configuração.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div style={{ display: "flex", justifyContent: "center", padding: 40 }}><CircularProgress size={24} /></div>;

  return <div style={{ width: "100%", maxWidth: 720, padding: "8px 4px 20px" }}>
    <Typography variant="h6" style={{ color: "#243a30", fontWeight: 700, marginBottom: 8 }}>IA dos relatórios</Typography>
    <Typography variant="body2" style={{ color: "#5f6f66", lineHeight: 1.6, marginBottom: 18 }}>
      Esta configuração vale para todas as empresas. Somente o administrador da instalação pode configurar a chave.
    </Typography>

    <div style={{ display: "grid", gap: 14, padding: 18, border: "1px solid #dce5df", borderRadius: 12, background: "#fff" }}>
      <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
        <div>
          <Typography variant="subtitle2" style={{ color: "#263b31", fontWeight: 700 }}>Serviço de relatórios</Typography>
          <Typography variant="caption" style={{ color: "#718078" }}>Modelo: {config.model}</Typography>
        </div>
        <FormControlLabel control={<Switch checked={config.enabled} onChange={event => setConfig(previous => ({ ...previous, enabled: event.target.checked }))} color="primary" />}
          label={config.enabled ? "Ativado" : "Desativado"} />
      </div>

      <div style={{ padding: "11px 13px", borderRadius: 9, background: "#f4f7f5", color: "#586a60", fontSize: 12 }}>
        {config.configured ? <>Chave configurada{config.maskedKey ? ` · ${config.maskedKey}` : ""}. Deixe o campo vazio para manter a chave atual.</> : "Nenhuma chave configurada. Informe uma chave para habilitar a geração de relatórios."}
      </div>

      <TextField id="ai-reports-api-key" label="Nova chave de API" type="password" value={apiKey} onChange={event => setApiKey(event.target.value)}
        variant="outlined" size="small" fullWidth autoComplete="new-password" inputProps={{ autoComplete: "new-password" }}
        placeholder={config.configured ? "Deixe vazio para preservar a chave atual" : "Insira a chave da API"} />

      {errorMessage && <div role="alert" style={{ color: "#9d241d", background: "#fff2f0", border: "1px solid #f0b8b2", borderRadius: 8, padding: 10, fontSize: 12 }}>{errorMessage}</div>}
      {message && <div role="status" style={{ color: "#19583e", background: "#eef8f1", border: "1px solid #c5e5cf", borderRadius: 8, padding: 10, fontSize: 12 }}>{message}</div>}

      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" color="primary" onClick={handleSave} disabled={saving} startIcon={saving ? <CircularProgress size={15} color="inherit" /> : null}>
          {saving ? "Salvando…" : "Salvar configuração"}
        </Button>
      </div>
    </div>
  </div>;
};

export default AiReports;
